import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "tab-shell" }
const _hoisted_2 = { class: "tab-head" }
const _hoisted_3 = { class: "filter-row" }
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "form-card"
}
const _hoisted_6 = { class: "form-title" }
const _hoisted_7 = { class: "form-grid" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "field" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "field" }
const _hoisted_16 = { class: "field" }
const _hoisted_17 = {
  key: 0,
  class: "form-error"
}
const _hoisted_18 = { class: "form-actions" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 1,
  class: "empty-hint"
}
const _hoisted_21 = {
  key: 2,
  class: "empty-hint"
}
const _hoisted_22 = {
  key: 3,
  class: "cards-grid"
}
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = { class: "card-title" }
const _hoisted_25 = {
  key: 0,
  class: "card-meta"
}
const _hoisted_26 = { class: "budget-row" }
const _hoisted_27 = { class: "budget-val" }
const _hoisted_28 = {
  key: 1,
  class: "budget-row"
}
const _hoisted_29 = { class: "budget-val" }
const _hoisted_30 = {
  key: 2,
  class: "progress-section"
}
const _hoisted_31 = { class: "progress-bar-bg" }
const _hoisted_32 = { class: "progress-labels" }
const _hoisted_33 = { class: "progress-saldo" }
const _hoisted_34 = {
  key: 3,
  class: "breakdown-grid"
}
const _hoisted_35 = {
  key: 0,
  class: "breakdown-item"
}
const _hoisted_36 = { class: "b-val" }
const _hoisted_37 = {
  key: 1,
  class: "breakdown-item"
}
const _hoisted_38 = { class: "b-val" }
const _hoisted_39 = {
  key: 2,
  class: "breakdown-item"
}
const _hoisted_40 = { class: "b-val" }
const _hoisted_41 = {
  key: 3,
  class: "breakdown-item"
}
const _hoisted_42 = { class: "b-val" }
const _hoisted_43 = {
  key: 4,
  class: "breakdown-item"
}
const _hoisted_44 = { class: "b-val" }
const _hoisted_45 = { class: "card-footer" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "tab-title" }, "Centros de Custo", -1)),
      (!_ctx.showForm)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-primary",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openForm()))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("svg", {
              width: "13",
              height: "13",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.2"
            }, [
              _createElementVNode("line", {
                x1: "12",
                y1: "5",
                x2: "12",
                y2: "19"
              }),
              _createElementVNode("line", {
                x1: "5",
                y1: "12",
                x2: "19",
                y2: "12"
              })
            ], -1),
            _createTextVNode(" Novo Centro de Custo ", -1)
          ]))]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        class: "filter-select",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.projectFilter) = $event))
      }, [
        _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "Todas as obras", -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
          return (_openBlock(), _createElementBlock("option", {
            key: p.id,
            value: p.id
          }, _toDisplayString(p.name), 9, _hoisted_4))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.projectFilter]
      ])
    ]),
    (_ctx.showForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.editId ? 'Editar Centro de Custo' : 'Novo Centro de Custo'), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "field-label" }, "Nome *", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.nome) = $event)),
                placeholder: "Ex: Estrutura Bloco A"
              }, null, 512), [
                [_vModelText, _ctx.form.nome]
              ])
            ]),
            _createElementVNode("label", _hoisted_9, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "field-label" }, "Obra", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "field-input",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.projectId) = $event))
              }, [
                _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "Selecione...", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (p) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: p.id,
                    value: p.id
                  }, _toDisplayString(p.name), 9, _hoisted_10))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.form.projectId]
              ])
            ]),
            _createElementVNode("label", _hoisted_11, [
              _cache[18] || (_cache[18] = _createElementVNode("span", { class: "field-label" }, "Orçamento Total (R$)", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                type: "number",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.orcamentoTotal) = $event)),
                min: "0",
                step: "0.01",
                placeholder: "0,00"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.orcamentoTotal,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "field" }, null, -1)),
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "field--full form-section-title" }, "Breakdown por categoria", -1)),
            _createElementVNode("label", _hoisted_12, [
              _cache[19] || (_cache[19] = _createElementVNode("span", { class: "field-label" }, "Mão de Obra (R$)", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                type: "number",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.orcamentoMaoObra) = $event)),
                min: "0",
                step: "0.01",
                placeholder: "0,00"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.orcamentoMaoObra,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_13, [
              _cache[20] || (_cache[20] = _createElementVNode("span", { class: "field-label" }, "Materiais (R$)", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                type: "number",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.orcamentoMateriais) = $event)),
                min: "0",
                step: "0.01",
                placeholder: "0,00"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.orcamentoMateriais,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_14, [
              _cache[21] || (_cache[21] = _createElementVNode("span", { class: "field-label" }, "Equipamentos (R$)", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                type: "number",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.orcamentoEquipamentos) = $event)),
                min: "0",
                step: "0.01",
                placeholder: "0,00"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.orcamentoEquipamentos,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_15, [
              _cache[22] || (_cache[22] = _createElementVNode("span", { class: "field-label" }, "Serviços (R$)", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                type: "number",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.orcamentoServicos) = $event)),
                min: "0",
                step: "0.01",
                placeholder: "0,00"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.orcamentoServicos,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_16, [
              _cache[23] || (_cache[23] = _createElementVNode("span", { class: "field-label" }, "Outros (R$)", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "field-input",
                type: "number",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.orcamentoOutros) = $event)),
                min: "0",
                step: "0.01",
                placeholder: "0,00"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.form.orcamentoOutros,
                  void 0,
                  { number: true }
                ]
              ])
            ])
          ]),
          (_ctx.formError)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.formError), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "btn-save",
              type: "button",
              disabled: _ctx.saving,
              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
            }, _toDisplayString(_ctx.saving ? 'Salvando...' : 'Salvar'), 9, _hoisted_19),
            _createElementVNode("button", {
              class: "btn-cancel",
              type: "button",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeForm && _ctx.closeForm(...args)))
            }, "Cancelar")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, "Carregando..."))
      : (_ctx.filteredCcs.length === 0 && !_ctx.showForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[26] || (_cache[26] = [
            _createElementVNode("svg", {
              width: "36",
              height: "36",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.4"
            }, [
              _createElementVNode("line", {
                x1: "12",
                y1: "1",
                x2: "12",
                y2: "23"
              }),
              _createElementVNode("path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" })
            ], -1),
            _createTextVNode(" Nenhum centro de custo cadastrado. ", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredCcs, (cc) => {
              return (_openBlock(), _createElementBlock("article", {
                key: cc.id,
                class: "cc-card"
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(cc.nome), 1),
                  (cc.projectName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(cc.projectName), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_26, [
                    _cache[27] || (_cache[27] = _createElementVNode("span", { class: "budget-label" }, "Previsto:", -1)),
                    _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.formatCurrency(cc.orcamentoTotal)), 1)
                  ]),
                  (cc.realizado !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "budget-label" }, "Realizado:", -1)),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formatCurrency(cc.realizado)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (cc.orcamentoTotal > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["progress-bar-fill", _ctx.progressClass(cc)]),
                            style: _normalizeStyle({ width: _ctx.progressPct(cc) + '%' })
                          }, null, 6)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["progress-pct", _ctx.progressClass(cc)])
                          }, _toDisplayString(_ctx.progressPct(cc).toFixed(1)) + "%", 3),
                          _createElementVNode("span", _hoisted_33, "Saldo: " + _toDisplayString(_ctx.formatCurrency((cc.orcamentoTotal || 0) - (cc.realizado || 0))), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.hasBreakdown(cc))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        (cc.orcamentoMaoObra)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _cache[29] || (_cache[29] = _createElementVNode("span", { class: "b-label" }, "Mão de Obra", -1)),
                              _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.formatCurrency(cc.orcamentoMaoObra)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (cc.orcamentoMateriais)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              _cache[30] || (_cache[30] = _createElementVNode("span", { class: "b-label" }, "Materiais", -1)),
                              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.formatCurrency(cc.orcamentoMateriais)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (cc.orcamentoEquipamentos)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _cache[31] || (_cache[31] = _createElementVNode("span", { class: "b-label" }, "Equipamentos", -1)),
                              _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.formatCurrency(cc.orcamentoEquipamentos)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (cc.orcamentoServicos)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "b-label" }, "Serviços", -1)),
                              _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.formatCurrency(cc.orcamentoServicos)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (cc.orcamentoOutros)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                              _cache[33] || (_cache[33] = _createElementVNode("span", { class: "b-label" }, "Outros", -1)),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.formatCurrency(cc.orcamentoOutros)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("button", {
                    class: "card-btn",
                    type: "button",
                    onClick: ($event: any) => (_ctx.openForm(cc))
                  }, "Editar", 8, _hoisted_46),
                  _createElementVNode("button", {
                    class: "card-btn card-btn--warn",
                    type: "button",
                    onClick: ($event: any) => (_ctx.remove(cc.id))
                  }, "Excluir", 8, _hoisted_47)
                ])
              ]))
            }), 128))
          ]))
  ]))
}